(function() {

  // Equalize product card title heights within each carousel/grid
  function equalizeProductTitles() {
    document.querySelectorAll('[data-carousel], .js-grid').forEach(function(container) {
      var titles = Array.from(container.querySelectorAll('.product__grid__title'));
      if (titles.length < 2) return;
      titles.forEach(function(t) { t.style.minHeight = ''; });
      var maxH = Math.max.apply(null, titles.map(function(t) { return t.offsetHeight; }));
      if (maxH > 0) titles.forEach(function(t) { t.style.minHeight = maxH + 'px'; });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(equalizeProductTitles, 300);
  });

  document.addEventListener('theme:resize', function() {
    setTimeout(equalizeProductTitles, 150);
  });

  // ─── Scroll-lock watchdog ─────────────────────────────────────────────────
  // The Postscript SMS popup locks body scroll (overflow:hidden + ps-scroll-lock)
  // but doesn't always release it after closing, freezing the page.
  // We watch the body directly and force-release when no overlay is visible.

  function isAnyOverlayOpen() {
    // Theme modals / drawers
    if (document.querySelector('.modal[aria-hidden="false"]')) return true;
    if (document.querySelector('[aria-modal="true"]')) return true;
    if (document.querySelector('[data-drawer].is-visible')) return true;
    if (document.querySelector('.cart-drawer.is-visible')) return true;
    if (document.querySelector('.popdown.is-visible')) return true;
    if (document.querySelector('.search-popdown.is-visible')) return true;
    if (document.querySelector('.popout-list--visible')) return true;
    if (window.theme && window.theme.state && window.theme.state.cartOpen) return true;
    // Postscript popup
    if (document.querySelector('.ps-popup, .ps-widget, [data-ps-popup], #postscript-subscriber-widget, .postscript-popup')) return true;
    // Generic: any visible fixed overlay with a backdrop
    if (document.querySelector('.modal-overlay.is-visible, .overlay.is-visible')) return true;
    return false;
  }

  function forceReleaseScroll() {
    if (!isAnyOverlayOpen()) {
      // Release via theme event
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      // Also directly restore body (catches Postscript's own lock)
      document.body.style.overflow = '';
      document.body.classList.remove('ps-scroll-lock');
      document.body.removeAttribute('data-scroll-lock');
      document.body.removeAttribute('data-scroll-lock-saved-overflow-y-property');
      document.body.removeAttribute('data-scroll-lock-saved-inline-overflow-y-property');
      document.documentElement.removeAttribute('data-scroll-locked');
    }
  }

  var lockCheckInterval = null;

  function isBodyLocked() {
    return document.body.style.overflow === 'hidden' ||
           document.body.classList.contains('ps-scroll-lock') ||
           document.documentElement.hasAttribute('data-scroll-locked');
  }

  function startWatchdog() {
    clearInterval(lockCheckInterval);
    lockCheckInterval = setInterval(function() {
      if (!isBodyLocked()) {
        clearInterval(lockCheckInterval);
        return;
      }
      forceReleaseScroll();
    }, 250);
  }

  // Watch the body for scroll lock being applied
  var bodyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (isBodyLocked()) {
        startWatchdog();
      } else {
        clearInterval(lockCheckInterval);
      }
    });
  });

  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['style', 'class', 'data-scroll-lock']
  });

  // Also watch <html> for data-scroll-locked
  var htmlObserver = new MutationObserver(function() {
    if (isBodyLocked()) startWatchdog();
    else clearInterval(lockCheckInterval);
  });
  htmlObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-scroll-locked']
  });

  // Escape key fallback
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') setTimeout(forceReleaseScroll, 400);
  });

})();
